import {Component, Input, OnInit} from '@angular/core';
import {AutoUnsubscribe} from '@secca/shared/decorators/auto-unsubscribe';
import {DropdownDictionary} from '@secca/shared/models/dropdownDictionary';
import {SupplierInvoiceService} from '@secca/core/services/supplier-invoice.service';
import {Dictionary} from '@secca/shared/models/dictionary';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {SupplierInvoice} from '@secca/shared/models/supplierInvoice';
import {forkJoin, Observable} from 'rxjs';

@Component({
  selector: 'app-credit-modal-content',
  templateUrl: 'credit-modal-content.component.html',
  styleUrls: ['credit-modal-content.component.scss'],
  standalone: false,
})
@AutoUnsubscribe
export class CreditModalContentComponent implements OnInit {
  invoiceItems: DropdownDictionary[] = [];
  selectedInvoiceItem: string;

  @Input() supplierInvoiceId: number;

  constructor(
              public activeModal: NgbActiveModal,
              private supplierInvoiceService: SupplierInvoiceService,
              ) {
  }

  ngOnInit() {
    console.log('Loading invoice items for supplierInvoiceId ' + this.supplierInvoiceId);

    this.supplierInvoiceService.getCoordinationCaseCreditNoteOptions(this.supplierInvoiceId).subscribe(supplierInvoiceIds => {
      console.log('Found ' + supplierInvoiceIds.length + ' supplier invoices');
      const invoices: DropdownDictionary[] = [];

      const allSupplierInvoices: Observable<SupplierInvoice>[] = supplierInvoiceIds.map(invoiceId => {
        return this.supplierInvoiceService.getSupplierInvoice(invoiceId);
      });

      forkJoin(allSupplierInvoices).subscribe(supplierInvoices => {
        for (const supplierInvoice of supplierInvoices) {
          invoices.push(new Dictionary(supplierInvoice.id.toString(), supplierInvoice.getInvoiceNumber()));
        }
        this.invoiceItems = invoices;
      });
    });
  }

  creditICCSupplier(): void {
    if (this.selectedInvoiceItem) {
      const selectedInvoiceId = Number(this.selectedInvoiceItem);
      this.supplierInvoiceService
        .createCoordinationCaseCreditNoteSplitInvoice(this.supplierInvoiceId, selectedInvoiceId).subscribe(splitInvoice => {
        this.activeModal.close(splitInvoice);
      });
    }
  }

  serviceItemChange(selected: string): void{
    this.selectedInvoiceItem = selected;
  }

  isCreditButtonEnabled(): boolean {
    return this.invoiceItems.length > 0 && this.selectedInvoiceItem !== undefined;
  }
}
